import tw, { styled } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-4 md:p-6 h-full relative`}

	.midFadedBg {
		background: rgba(50, 50, 50, 0.5);
		backdrop-filter: blur(4px);
		border-radius: 50px;
	}
`;

export const TimelineContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
	/* @media (max-width: 1217px) {
			flex-direction: row;
			flex-wrap: nowrap;
			height: auto;
			overflow-x: scroll;
		} */
	/* } */
`;

export const StoryMode = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	gap: 8px;
	overflow-x: auto;
`;

export const StoryAvatar = styled.div`
	cursor: pointer;
	padding: 2px;
	border-radius: 50%;
	border-width: 2px;
	border-style: solid;
	border-color: #ff9249;

	/* border-image: linear-gradient( red, orange) 2; */
`;

export const AvatarContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	align-items: center;
	justify-content: center;
`;
